import { faCheckCircle, faClock } from '@fortawesome/pro-solid-svg-icons';
import { MediaQueries } from 'custom_hooks/useWindowSize';
import { Count } from 'pages/Dashboard/DeploymentAndValueDashboard/components/Counts';
import styled from 'styled-components';
import { round } from 'utils/number';

const EngagementWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-top: 1rem;

    @media ${MediaQueries.xlargeAndDown} {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto;
        justify-content: center;
        align-content: center;
        & > * {
            height: fit-content;
        }
    }
`;

type EngagementData = {
    AverageTimeToCloseDays: number;
    QuantifiedIssuesCount: number;
    TotalEligibleIssuesCount: number;
};

export function EngagementMetrics({ data }: { data: EngagementData | undefined }) {
    const quantifiedRatio = data
        ? `${data.QuantifiedIssuesCount} / ${data.TotalEligibleIssuesCount}`
        : undefined;

    const avgDays = data ? round(data.AverageTimeToCloseDays, 1) : undefined;

    return (
        <EngagementWrapper>
            <Count
                title="Avg. Time to Close"
                value={avgDays ?? null}
                suffix=" days"
                icon={faClock}
                info="Average number of days to close an issue once it is created"
            />
            <Count
                title="Quantified Issues"
                value={quantifiedRatio ?? null}
                icon={faCheckCircle}
                info="Number of Issues that have value quantified / number of value-eligible issues"
            />
        </EngagementWrapper>
    );
}
